import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'

import { ProductTypeEnum } from '../../../../lib/types/enums/product/product-type.enum'
import { CenterToJourneyInput } from '../../../../lib/types/models/center-to-journey/center-to-journey-input'
import { getTranslatedName } from '../../../../lib/utils/functions/translation.functions'

type Props = {
  mode: 'view' | 'fill'
  centerToJourney: CenterToJourneyInput
}

const JourneyCardHeader = ({ centerToJourney, mode }: Props) => {
  const { journey } = centerToJourney
  const date = `${DateFormatter.DDMMYYYY(journey.date.departureDate)} à ${DateFormatter.DDMMYYYY(journey.date.returnDate)}`
  const secondaryOptions = journey.secondaryOptions
    .map((secondaryOption) => getTranslatedName(secondaryOption.option))
    .join(' , ')
  let title = `${journey.reference} - ${getTranslatedName(journey.mainOption)} - ${secondaryOptions}`

  if (journey.date.product.type === ProductTypeEnum.ONE_TO_ONE) {
    title += ` - ${journey.date.product.numberOfHoursPerWeek}h de cours / sem`
  }

  if (mode === 'view') {
    title += ` - ${date}`
  }

  return (
    <div className="flex gap-2 items-center bg-primary-light rounded-lg px-2 py-3">
      <Typography variant="tag" color={tailwindColors.primary.DEFAULT}>
        {title}
      </Typography>
      {mode === 'fill' && (
        <Badge
          variant="white"
          className="border-none"
          textColor={tailwindColors.primary.DEFAULT}
          text={date}
        />
      )}
      {mode === 'view' && (
        <Badge
          variant="white"
          className="border-none"
          textColor={tailwindColors.primary.DEFAULT}
          text={`${centerToJourney.maxNumberOfStudentPlaces} jeunes`}
        />
      )}
    </div>
  )
}

export default JourneyCardHeader
